<template>
    <div class="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-10">
        <div class="w-full max-w-md bg-black border-none text-white rounded-lg">
            <!-- Header -->
            <div class="p-6">
                <h2 class="text-2xl font-bold text-center">{{ title }}</h2>
                <p class="!text-lg text-white/90 text-center mt-2">{{ description }}</p>
            </div>

            <!-- Content -->
            <div class="px-6 pb-4">
                <p class="!text-base text-center text-white/90">{{ subtext }}</p>
                <p class="!text-sm text-white/70 mt-2 text-center">No se puede deshacer.</p>
            </div>

            <!-- Footer -->
            <div class="p-6 flex flex-col sm:flex-row gap-2 justify-center">
                <button
                    class="w-full sm:w-auto px-4 py-2 bg-white text-black rounded-md hover:bg-white/90 transition-colors"
                    @click="$emit('confirm')">
                    {{ confirmText }}
                </button>
                <button
                    class="w-full sm:w-auto px-4 py-2 text-white border border-white rounded-md hover:bg-white/10 transition-colors"
                    @click="$emit('cancel')">
                    {{ cancelText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChoiceModal',
    props: {
        title: {
            type: String,
            default: 'Estás a punto de disparar'
        },
        description: {
            type: String,
            default: 'Solo tenés una bala.'
        },
        subtext: {
            type: String,
            default: '¿Realmente creés que esta es la historia infiltrada?'
        },
        confirmText: {
            type: String,
            default: 'Si, disparar'
        },
        cancelText: {
            type: String,
            default: 'No, me arrepiento'
        }
    },
    emits: ['confirm', 'cancel']
}
</script>